// Event data structure
// Add your event information here
export const events = [
  {
    id: 6,
    slug: "cafe-v-lese-jun-2026",
    date: "2026-06-19",
    venue: "Café V lese",
    location: "Prague",
    time: "19:00",
    description: {
      en: "An evening of live music at Café V lese",
      cs: "Večer živé hudby v Café V lese",
    },
    link: "https://maps.app.goo.gl/3gUF5A9a3c8EqA8v6",
    displayInHero: true,
  },
  {
    id: 5,
    slug: "zizkova-siska-apr-2026",
    date: "2026-04-24",
    venue: "ŽiŽKOVŠiŠKA gallery",
    location: "Prague",
    description: { en: "An evening of authentic rock — complex rhythms, intricate melodies, and a sound we truly believe in", cs: "Večer autentického rocku — složité rytmy, propracované melodie a zvuk, ve který věříme" },
    link: "https://maps.app.goo.gl/Q8SRFeKTx6HNYx9F6",
    displayInHero: false,
    ticketsInfo: "cash",
    image: "/gallery/zizkov.jpeg",
  },
  {
    id: 1,
    slug: "chapeau-rouge-feb-2026",
    date: "2026-02-02",
    venue: "Chapeau Rouge",
    location: "Prague",
    description: { en: "Prog-Fusion Night", cs: "Prog-Fusion Noc" },
    link: "https://maps.app.goo.gl/1Egi6hqzgxqZxDav6",
    displayInHero: false,
    // Optional fields for modal:
    // image: "/images/events/event-1.jpg",
    // time: "21:00",
    // address: "Štupartská 17, Prague 1",
    // detailedDescription: "Full text...",
    // otherBands: [{ name: "Band Name", description: "...", link: "https://..." }],
    // ticketsInfo: "cash",
  },
  {
    id: 2,
    slug: "zizkova-siska-apr-2025",
    date: "2025-04-19",
    venue: "ŽiŽKOVŠiŠKA gallery",
    location: "Prague",
    description: { en: "Performance at ŽiŽKOVŠiŠKA", cs: "Koncert v ŽiŽKOVŠiŠKA" },
    link: "https://maps.app.goo.gl/Q8SRFeKTx6HNYx9F6",
    displayInHero: false,
  },
  {
    id: 3,
    slug: "zizkova-siska-nov-2024",
    date: "2024-11-23",
    venue: "ŽiŽKOVŠiŠKA gallery",
    location: "Prague",
    description: { en: "Performance at ŽiŽKOVŠiŠKA", cs: "Koncert v ŽiŽKOVŠiŠKA" },
    link: "https://maps.app.goo.gl/Q8SRFeKTx6HNYx9F6",
    displayInHero: false,
  },
  {
    id: 4,
    slug: "worklounge-dec-2024",
    date: "2024-12-22",
    venue: "WorkLounge Příkopy",
    location: "Prague",
    description: { en: "Performance at WorkLounge Příkopy", cs: "Koncert v WorkLounge Příkopy" },
    link: "https://maps.app.goo.gl/sdp89mGzZjqr5Ypn6",
    displayInHero: false,
  }
];
